import CM                                             from '@emersya/mpa-components-manager-lib';

export interface IMenuViewsComponentConfiguration extends IMenuComponentConfiguration {
};

/**
 * Menu  wich open a view on selection.
 * Each view has a title section in the menu
 **/
export abstract class MenuViewsComponent<
	TComponent extends MenuViewsComponent<TComponent, TConfiguration>,
	TConfiguration extends IMenuViewsComponentConfiguration
> extends MenuComponent<HTMLDivElement, TComponent, TConfiguration> {
	currentSection : SectionComponent | null = null;

	async open(childId : string) {  //eslint-disable-line require-await
		void childId;
		this.component_DOM.classList.add('opened');
	};

	async close() { //eslint-disable-line require-await
		this.component_DOM.classList.remove('opened');
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = MenuViewsComponent;
	export type Component = MenuViewsComponent<any, any>;
	export type Configuration = IMenuViewsComponentConfiguration;
}
;
// import './MenuAccordion.scss';
import { MenuComponent, IMenuComponentConfiguration } from '../Menu/Menu';
import { SectionComponent }                           from '../../Section/Section';
// CM.declare({
// 	id   : 'menu-views',
// 	type : MenuViewsComponent
// });
// export interface IMenuComponentConfiguration extends CM.IComponentConfiguration {
// };
// export abstract class MenuComponent<
// 	TNode extends HTMLElement,
// 	TConfiguration extends IMenuComponentConfiguration
// > extends CM.DOMComponent<TNode, TConfiguration> {

// 	constructor(
// 		descriptor    : ConstructorParameters<typeof CM.Component>[0],
// 		configuration : TConfiguration
// 	) {
// 		super(descriptor, configuration);
// 	};
// };
// export namespace NS {
// 	export type Configuration = IMenuComponentConfiguration;
// 	export const Component    = MenuComponent;
// 	export type Component<
// 		X extends	HTMLElement,
// 		Y
// 	> = MenuComponent<X, Y>;
// };
// import * as STD from '@libs/UtilSTD/index';
